import { localStorage } from '@fiverr-private/futile';

const getStorageKey = (userId) => `buyer.listing.favorites.education.${userId}`;

export const hasUserFavoritesEducation = (userId) => !!localStorage.get(getStorageKey(userId));
export const setUserFavoritesEducation = (userId) => localStorage.set(getStorageKey(userId), true);
